import React, { FC, useState } from 'react';
import { PageWrapper, User, UserForm, useShowAlertPopup } from '@dew21/ui';
import axios from 'axios';
import { useHistory } from 'react-router';

export const AddUser: FC = (props) => {
  const [user, setUser] = useState<User | null>(null);
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();

  return <PageWrapper
    breadCrumb={[{ title: 'Benutzer', path: '/users' }, { title: 'Hinzufügen', path: '/users/add' }]}
    marginal={{
      items: [],
    }}>
    <UserForm
      onCancel={() => {
        history.push('/users');
      }}
      onChange={(payload) => {
        if (payload.user !== null) {
          axios.post(`/api/users/create`, payload.user).then((response) => {
            setUser(response.data);
            showNotificationBanner({ renderContent: () => <>Der Benutzer wurde angelegt.</> });
            history.push(`/users/${response.data.id}`);
          }).catch((error) => {
            switch (error?.response?.status || 500) {
              case 409:
                showNotificationBanner({ error: true, renderContent: () => <>Es existiert bereits ein Benutzer mit dieser E-Mail-Adresse.</> });
                break;
              default:
                showNotificationBanner({ error: true, renderContent: () => <>Bitte kontrolieren Sie ihre Eingaben.</> });
                break;
            }
            console.log(error);
          });
        }
      }}/>
  </PageWrapper>;
};
